module.exports = __webpack_public_path__ + "img/22.20e3b855.webp";